import React, { useEffect, useRef, useState } from "react";
import "styles/TermsAndConditions.css";
import PageLayout from "components/PageLayout";
import { fetchTermsAndConditions } from "utils/api";

const LOGO_SRC =
  "/static/media/BiosciencesAndTechnology.68f99ceb334dfcde911552aca53e4fe9.svg";

const PUBLIC_TERMS_CANDIDATES = [
  process.env.REACT_APP_TERMS_PATH,
  `${process.env.PUBLIC_URL || ""}/terms.html`,
].filter(Boolean);

const TermsAndConditions = ({ onAccept }) => {
  const [isAcceptable, setIsAcceptable] = useState(false);
  const [isScrollable, setIsScrollable] = useState(false);
  const [termsContent, setTermsContent] = useState("");
  const [loadingError, setLoadingError] = useState("");
  const scrollRef = useRef(null);

  const parseHtml = (htmlText) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, "text/html");
    return doc.body?.innerHTML || htmlText || "";
  };

  const looksLikeAppIndex = (text) =>
    /<div\s+id=["']root["']>/i.test(text) ||
    /<title>.*React App.*<\/title>/i.test(text);

  useEffect(() => {
    const loadTerms = async () => {
      for (const path of PUBLIC_TERMS_CANDIDATES) {
        try {
          const res = await fetch(path, { credentials: "include", cache: "no-cache" });
          if (!res.ok) continue;
          const text = await res.text();
          if (!text || looksLikeAppIndex(text)) continue;
          setTermsContent(parseHtml(text));
          setLoadingError("");
          return;
        } catch {}
      }
      try {
        const htmlFromApi = await fetchTermsAndConditions();
        if (htmlFromApi && String(htmlFromApi).trim()) {
          setTermsContent(parseHtml(htmlFromApi));
          setLoadingError("");
          return;
        }
      } catch {}
      setLoadingError("Unable to load Terms & Conditions. Please try again.");
    };
    loadTerms();
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const scrollable = el.scrollHeight > el.clientHeight + 1;
    setIsScrollable(scrollable);
    setIsAcceptable(!scrollable);
  }, [termsContent]);

  const handleScroll = (e) => {
    if (!isScrollable) return;
    const el = e.currentTarget;
    const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 2;
    if (atBottom) setIsAcceptable(true);
  };

  const handleAccept = () => {
    if (!isAcceptable) return;
    onAccept?.();
  };

  return (
    <PageLayout>
      <div className="tc-paper">
        <div className="tc-header">
          <img src={LOGO_SRC} alt="Institute of Biosciences and Technology" className="logo-image" />
        </div>

        <div className="tc-divider" />
        <h2 className="tc-title">Terms &amp; Conditions</h2>

        <div
          ref={scrollRef}
          className="tc-terms"
          style={{ marginTop: "16px" }}
          onScroll={handleScroll}
          dangerouslySetInnerHTML={{ __html: termsContent }}
        />
        {loadingError && <div className="tc-error">{loadingError}</div>}

        <button
          className={`tc-accept ${isAcceptable ? "enabled" : ""}`}
          onClick={handleAccept}
          disabled={!isAcceptable}
        >
          ACCEPT
        </button>
      </div>
    </PageLayout>
  );
};

export default TermsAndConditions;